import React from "react";
import Typography from '@material-ui/core/Typography'
import IL_404  from "../../assets/images/404.svg"
import useStyles from "./style"


function NotFound() {
    const classes = useStyles()
  return (
    <div className={classes.root}>
      <img src={IL_404} alt="404" className={classes.img} />
      <Typography className={classes.title} variant="caption">
        An Error Occurred
      </Typography>
    </div>
  );
}

export default NotFound;
